import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from '@trackman/web-shared-components';
import { grey } from 'styles/Colors';

export const PlayNumber = styled.div<{ isError: boolean; isFirstPlayInInning: boolean }>`
  font-size: 18px;
  color: ${(props) => (props.isError ? '#EE1B34' : '#000000')};
  width: 45px;
  margin-top: ${(props) => (props.isFirstPlayInInning ? '18px' : 0)};
`;

export const ValidationCellWrapper = styled.div<{
  hidden?: boolean;
  isSelected?: boolean;
  isError?: boolean;
}>`
  user-select: none;
  display: flex;
  padding-left: 10px;
  justify-content: left;
  align-items: center;
  font-size: 15px;
  font-family: 'Lato';
  font-weight: bold;
  letter-spacing: 0.42px;
  border: 1px solid #f5f5f5;
  ${(props) =>
    props.hidden &&
    css`
      display: none !important;
    `}
  background-color: ${(props) => (props.isSelected ? '#fffbb3' : props.isError ? '#FCD1D7' : 'transparent')};
`;

export const LiveOrWarmupButton = styled((props) => <Button {...props} />)`
  &&& {
    text-align: center;
    font-size: 10px;
    width: 120px;
    min-width: 110px;
    margin-left: 1px;
    height: 25px;
  }
`;

export const StickyInningSeparator = styled.div`
  height: 18px;
  background-color: #f8f8f8;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;

export const WarmupPitchLabel = styled.div`
  color: ${grey};
  font-size: 15px;
  width: 100%;
`;
